import { notifUtils } from "../components/NotifUtils/NotifUtils";
import { handleError } from "../components/Utils/Utils";
import PickupService from "../Services/PickupService";

export const getList = (store, value, refresh) => {
  const isLoading = !store.state.isLoading;
  const status = 200;
  store.setState({ isLoading, status });
  PickupService.getList(value)
    .then((response) => {
      let data = response.data;
      const isLoading = false;
      const status = data.message;
      store.state.lastPage = false;
      store.state.data = refresh ? data : store.state.data.concat(data);
      if (data.length < parseInt(value.num)) {
        store.state.lastPage = true;
      }
      store.setState({
        isLoading,
        header: response.headers,
        status,
      });
    })
    .catch((error) => {
      handleError(error);
    });
};

export const store = async (store, value) => {
  try {
    const response = await PickupService.storeData(value);
    const data = response.data;
    notifUtils("Successfully Created Pickup Point", "success");
    return data;
  } catch (error) {
    handleError(error);
    return error;
  }
};

export const put = async (store, value, index) => {
  try {
    const response = await PickupService.putData(index, value);
    const data = response.data;
    notifUtils("Successfully Updated Pickup Point", "success");
    return data;
  } catch (error) {
    handleError(error);
    return error;
  }
};
